module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/new/jarvis_imagem-574c522c8da2557f398bba1bc0fd2bd2.jpg";